// src/store/purchaseModalManagment/actions.ts

import { Dispatch } from 'redux';

import {
  OPEN_PURCHASE_MODAL,
  CLOSE_PURCHASE_MODAL,
  PurchaseModalActionTypes,
} from './types';

export const openPurchaseModal = (
  cartId: number,
  amount: number,
  label : string,
) => (dispatch: Dispatch<PurchaseModalActionTypes>) => {
  dispatch({
    type: OPEN_PURCHASE_MODAL,
    payload: { cartId, amount, label },
  });
};

export const closePurchaseModal = () => (dispatch: Dispatch<PurchaseModalActionTypes>) => {
  dispatch({ type: CLOSE_PURCHASE_MODAL });
};
